(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-list"]) return;
  try {
    
(function () {
  const productId = document.getElementById('pid-holder').innerHTML;
  console.log(productId)
  if(productId!==""){
    fetch(`https://api.okendo.io/v1/stores/ce8798f7-5c1f-4523-8d5c-074c9846d1f6/products/shopify-${productId}/reviews`)
    .then(response => response.json())
    .then(data => {
      document.getElementById('review-count-number').textContent = data.reviews.length;
      const averageRating = (Math.round(data.reviews.reduce((total, review) => total + review.rating, 0) / data.reviews.length * 10) / 10).toFixed(1);
      
      document.getElementById('review-average-rating').textContent = averageRating !== 'NaN' ? averageRating : '0.0';

      data.reviews.forEach(review => {
        const reviewCard = document.createElement('div');
        reviewCard.classList.add('review-card');
        
        const dateAndReviewer = document.createElement('p');
        const date = new Date(review.dateCreated);
        const formattedDate = date.toISOString().split('T')[0];
        const nameAndDate = `${review.reviewer.displayName} - ${formattedDate}`;
        dateAndReviewer.textContent = nameAndDate;
        dateAndReviewer.classList.add('nameAndDate');
        reviewCard.appendChild(dateAndReviewer);
        
        const title = document.createElement('h3');
        title.textContent = review.title;
        reviewCard.appendChild(title);
        
        const body = document.createElement('p');
        body.textContent = review.body;
        body.classList.add('review-body');
        reviewCard.appendChild(body);
        const rating = document.createElement('span');      
        for (let i = 0; i < 5; i++) {
          if (i >= review.rating) {
            rating.innerHTML += `<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
              <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clip-rule="evenodd" />
              </svg></span>`;
            } else {
              rating.innerHTML += `<span class="filled-star"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clip-rule="evenodd" />
                </svg></span>`;
              }
            }
            
            rating.classList.add('rating');
            reviewCard.appendChild(rating);
            
            document.getElementById('review-list-wrapper').appendChild(reviewCard);
            
            
            
            const wrapper = document.getElementById('review-list-wrapper');
            if (wrapper.scrollWidth > wrapper.clientWidth) {
              if (!document.getElementById('next-arrow')) {
                const nextArrow = document.createElement('button');
                  nextArrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>`;
                  nextArrow.id = 'next-arrow';
                  nextArrow.addEventListener('click', () => {
                    const wrapper = document.getElementById('review-list-wrapper');
                    wrapper.scrollTo({
                      left: wrapper.scrollLeft + window.innerWidth * 0.5,
                      behavior: 'smooth'
                    });
                  });
                  document.getElementById('review-list-section').appendChild(nextArrow);
                }
                if (!document.getElementById('prev-arrow')) {
                  const prevArrow = document.createElement('button');
                  prevArrow.innerHTML += `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                    </svg>`;
                    prevArrow.id = 'prev-arrow';
                    prevArrow.addEventListener('click', () => {
                      const wrapper = document.getElementById('review-list-wrapper');
                      wrapper.scrollTo({
                        left: wrapper.scrollLeft - window.innerWidth * 0.5,
                        behavior: 'smooth'
                      });
                    });
                    document.getElementById('review-list-section').appendChild(prevArrow);
                  }
                }

                const ratingCountElement = document.querySelector('.okeReviews-reviewsSummary-ratingCount');
                if (ratingCountElement) {
                  ratingCountElement.textContent = `${averageRating} (${data.reviews.length})`;
                  ratingCountElement.style.display = 'inline-block';
                }
                const productReviewSummary = document.querySelector('.product-review-summary');
                if (productReviewSummary) {
                  productReviewSummary.style.cursor = 'pointer';
                }
                if (productReviewSummary) {
                  productReviewSummary.addEventListener('click', () => {
                    document.querySelector("#review-list-section").scrollIntoView({ behavior: 'smooth' });
                  });
                }
                
                const observer = new IntersectionObserver((entries, observer) => {
                  entries.forEach(entry => {
                    if (entry.isIntersecting) {
                      entry.target.classList.add('visible');
                    } else {
                      entry.target.classList.remove('visible');
                    }
                  });
                });
                document.querySelectorAll('.review-card').forEach(card => {
                  observer.observe(card);
                });
                
                
              });
            })
            
          }
        })()
        
  } catch(e) { console.error(e); }
})();
})();
